import axiosClient from './utils/axiosClient';

export const MODERATOR_REQUEST_URI = 'moderator/request';


export function sendModeratorRequest(moderatorRequest) {
    return axiosClient.post(`${MODERATOR_REQUEST_URI}`, moderatorRequest);
}
